


































import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoPosts from '@/business/post/components/posts.vue'
import { activeUser, activeUserIsOwner } from '@/shared/utils/user'
import { OrganisationLiteResponse } from '@/api/generated'
import { Injector } from '@/config/dependency-injection'
import { OffersModule } from '@/business/offers/store/offers-module'
import { Post } from '@/business/post/models/post'
import { AuthenticationService } from '@/authentication/authentication-service'
import { PostUpdate } from '@/business/post/models/post-update'
import { OfferPostDataSource } from '@/business/offers/offer-post-data-source'
import { DataSourcePaginator } from '@/shared/models/data/data-source-paginator'
import { Hooks } from '@/shared/interfaces/hooks'
import UnifyButton from '@/shared/components/unify/unify-button.vue'

@Component({
  name: 'offer-posts',
  components: { UnifyButton, RespondecoPosts },
})
export default class OfferPosts extends Vue implements Hooks {
  private offersModule = Injector.get(OffersModule)

  private dataSource!: OfferPostDataSource
  private paginator!: DataSourcePaginator<Post>

  get hasMorePosts() {
    const posts = this.offersModule.offer.posts

    return posts.total > posts.size
  }

  get isLoadingPosts(): boolean {
    return this.paginator.isSearching()
  }

  get isOwner() {
    return activeUserIsOwner(this.viewModel.offer.organisation.id)
  }

  get isPartner() {
    return this.partners.find(partner => partner.id === activeUser().organisation.id) !== undefined
  }

  get partners(): OrganisationLiteResponse[] {
    return this.viewModel.offer.partners.map(partner => partner.organisation)
  }

  get posts() {
    return this.dataSource.items
  }

  get viewModel() {
    return this.offersModule.offer
  }

  constructor() {
    super()

    this.dataSource = new OfferPostDataSource()
    this.paginator = new DataSourcePaginator(this.dataSource)
  }

  public mounted() {
    this.paginator.initialize()
  }

  public activeUserCanEditPost(post: Post): boolean {
    return Injector.get(AuthenticationService).authenticatedUser().id === post.author.id
  }

  public createPost(post: PostUpdate) {
    return this.dataSource.createPost(post)
  }

  public deletePost(post: Post) {
    return this.dataSource.deletePost(post)
  }

  public loadMorePosts(): void {
    this.paginator.next().update()
  }

  public updatePost(post: Post) {
    return this.dataSource.updatePost(post)
  }
}
